<template>
    <div v-if="!cookieExists" id="suscribe-newsletter">
        <a href="#" @click.prevent="close" class="close"></a>
        <svg viewBox="0 0 40 44" class="icon white" style="width:50px; height : 50px">
            <use xlink:href="#newsletter"></use>
        </svg>
        <p> Des astuces dans ta boite mail</p>
        <form v-if="!register" action="" @submit.prevent="submitForm">
            <input required type="email" v-model="email" placeholder="entrez votre adresse mail">
            <button class="btn small"> Envoyer</button>
        </form>
        <p v-if="register">{{ message }}</p>
    </div>
</template>
<script>
export default {
    data() {
        return {
            cookieExists: false,
            email: null,
            register: false,
            message: 'Vous êtes maintenant inscrit à la Newsletter.'
        }
    },
    mounted() {
        this.cookieExists = this.getCookie();
    },
    methods: {
        close()
        {
            document.cookie = 'nwRegisterW=true; expires=Fri, 31 Dec 9999 23:59:59 GMT';
            this.cookieExists = this.getCookie();
        },
        removeCookie()
        {
            document.cookie = "nwRegisterW=true; expires=Fri, 31 Dec 9999 23:59:59 GMT";
        },
        getCookie()
        {
            return document.cookie.replace(/(?:(?:^|.*;\s*)nwRegisterW\s*\=\s*([^;]*).*$)|^.*$/, "$1") || false;
        },
        submitForm()
        {
            axios.post('newsletter', {email: this.email})
            .then(()=>{

            }).catch(()=>{

            }).finally(()=>{
                this.register = true
                setTimeout(()=>{
                    this.close()
                }, 5000)                
            })
        }
    }
    
}
</script>